import React from "react";
import Modal from 'react-awesome-modal';
import { observer } from "mobx-react";
import store from '../Stores/SurveyStore'
import { deleteRowCtrl, deleteRowCtrlCallback } from "../../control";
import SurveyCondensedTable from "../SurveyCondensedTable";
import { NumberFormat } from "../../Enums/constants";
import { getTableDataDb } from "../../Services/IBS/DbService";

const DeleteRowModal = observer(() => {
    const closeDeleteModal = () => {
        store.showDeleteRowModal = false;
    }

    const deleteRow = async () => {
        //ibsStore.allTableResponses[props.tableName].splice(rowNum, 1)
        //delete from database
        await deleteRowCtrl(store.rowToDelete.RowID, store.rowToDelete.TableName);
        //await getTableDataDb("Benchmark", false);
        store.showDeleteRowModal = false; //would be delete modal instead
    }
    let rowName = "option";
    if (store.currentLandedPage == "assets") {
        rowName = "asset"
    } else if (store.currentLandedPage == "ltdpartnerships") {
        rowName = "partnership"

    } else if (store.currentLandedPage == "expenses") {
        rowName = "team"
    } else if (store.currentLandedPage == "benchmarks") {
        rowName = "benchmark"
    } else if (store.currentLandedPage == "customgroupings") {
        rowName = "custom asset"
    }

    return (
        <React.Fragment>
            <section>
                <Modal
                    visible={store.showDeleteRowModal}
                    width="600"
                    height="200"
                    effect="fadeInDown"
                    onClickAway={closeDeleteModal}
                >
                    <div className="helpModal">
                        <h3><i className="fas fa-trash-alt"></i> Delete this {rowName}?
                            <span onClick={closeDeleteModal} className="close-button topright">&times;</span>
                        </h3>

                        <hr/>
                        <div className="center-div">
                            <a onClick={closeDeleteModal} className="btn btn-info2 grey" role="button">Cancel</a>
                            <a onClick={deleteRow} className="btn btn-info2" role="button">Delete {rowName}</a><br/>
                        </div>

                    </div>
                </Modal>
            </section>

        </React.Fragment>
    );

});

export default DeleteRowModal;